<template>
  <el-table-column
    prop="address.address"
    label="Cím"
    show-overflow-tooltip
    min-width="250"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.address.address }}
    </template>
  </el-table-column>
</template>
<script>
export default {
  propName: 'address.address',
};
</script>
